<template>
  <div v-if="show" class="tw-border-2 tw-border-psi tw-rounded tw-pl-4 tw-pr-2 tw-py-3 tw-flex">
    <div class="tw-flex tw-flex-col">
      <div class="tw-text-sm tw-font-semibold tw-text-default">Legacy Navigation</div>
      <a
        :href="ALTERNATE_PORTAL_HELP_LINK"
        target="_blank"
        class="tw-text-default tw-text-xs tw-underline-offset-2"
        >Learn More</a
      >
    </div>
    <div class="tw-flex-grow tw-flex tw-flex-col tw-justify-center tw-items-end">
      <Toggle
        @change="openModal"
        :value="set"
        :target="!set"
        :disabled="modalOpen"
        :transitioning="modalOpen"
      />
    </div>
  </div>
</template>

<script>
import { computed, ref } from "vue";
import {
  isAvailable as isAlternatePortalAvailable,
  isSet as isAlternatePortalSet,
} from "@/utils/portalMode";
import constants from "@/utils/constants";
import NavigationImprovements from "@/components/smart/modals/NavigationImprovements";
import store from "@/store";
import Toggle from "@/components/display/Toggle";

export default {
  name: "PortalSwitch",
  components: {
    Toggle,
  },
  props: {},
  setup() {
    const modalOpen = ref(false);
    const set = ref(isAlternatePortalSet());

    const openModal = () => {
      modalOpen.value = true;
      store.dispatch("modals/open", {
        template: NavigationImprovements,
        close: () => {
          set.value = false;
          modalOpen.value = false;
        },
        confirm: () => {
          set.value = true;
          modalOpen.value = false;
        },
      });
    };

    const show = computed(() => isAlternatePortalAvailable());

    return {
      ALTERNATE_PORTAL_HELP_LINK: constants.LINKS.NEXCESS.KB.ALTERNATE_PORTAL,
      modalOpen,
      openModal,
      set,
      show,
    };
  },
};
</script>
